import { NavLink, Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { List, X } from "@phosphor-icons/react";

const nav = [
  { to: "/", label: "Home" },
  { to: "/solutions", label: "Solutions" },
  { to: "/platforms", label: "Platforms" },
  { to: "/blueprint", label: "Blueprint" },
  { to: "/architecture", label: "Architecture" },
  { to: "/about", label: "Why Bizlem" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-zinc-200"
          : "bg-white/70 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="container-x mx-auto flex items-center justify-between h-20 lg:h-24">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 group">
          <img
            src="/bizlem-logo.png"
            alt="Bizlem"
            className="h-10 lg:h-12 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium link-underline transition-colors ${
                  isActive ? "text-zinc-950" : "text-zinc-600 hover:text-zinc-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="header-book-consultation-btn"
            className="inline-flex items-center gap-2 bg-blue-600 text-white px-5 py-2.5 text-sm font-semibold hover:bg-blue-700 transition-colors shadow-sm"
          >
            Book a Consultation
            <span className="text-white/70">→</span>
          </Link>
        </div>

        <button
          data-testid="header-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 border border-zinc-300 hover:bg-zinc-100 transition"
        >
          {open ? <X size={20} weight="regular" /> : <List size={20} weight="regular" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-zinc-200 bg-white" data-testid="mobile-menu">
          <div className="container-x mx-auto py-4 flex flex-col gap-2">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${isActive ? "text-zinc-950" : "text-zinc-600"}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-book-consultation-btn"
              className="mt-3 inline-flex items-center justify-center bg-zinc-950 text-white px-5 py-3 text-sm font-semibold"
            >
              Book a Consultation →
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
